/**
 * Capitalizes the first character of a string.
 *
 * @param str The string to capitalize.
 * @return The string with the first character capitalized.
 */
export function capitalizeFirst(str: string): string {
  if (typeof str !== "string" || str.length === 0) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}
